module.exports = __webpack_public_path__ + "img/octopus-profile.e6db9a8a.svg";